import React from "react";

import colors from "../../theme";

import { Box, Grid, Card, CardContent, Typography } from "@mui/material";
import { useSelector } from "react-redux";

const CurrentBalance = ({ currentUserBalance }) => {
  const currency = useSelector((state) => state.currency.currency);

  return (
    <Box
      sx={{
        backgroundColor: colors.mainContentBgColor,
        display: { xs: "column", md: "flex" },
        alignItems: { xs: "", md: "center" },
        justifyContent: { xs: "none", md: "center" },
      }}
    >
      <Card
        sx={{
          backgroundColor: colors.mainContentBgColor,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: { md: "15vw" },
          my: 2,
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Grid container alignItems="center">
            <Grid
              item
              xs={12}
              my={0.5}
              mb={2}
              sx={{
                textAlign: "center",
                color: colors.primary,
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                Balance
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              my={0.5}
              sx={{
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography variant="h4" sx={{ marginRight: 1 }}>
                  {currentUserBalance ? currentUserBalance : "00.00"}
                </Typography>
                <Typography variant="h6" sx={{ marginTop: 1 }}>
                  {currency}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};
export default CurrentBalance;
